import account from "../../../locales/en-US/account.json";
import admin from "../../../locales/en-US/admin.json";
import common from "../../../locales/en-US/common.json";
import errors from "../../../locales/en-US/errors.json";
import feed from "../../../locales/en-US/feed.json";
import insights from "../../../locales/en-US/insights.json";
import reports from "../../../locales/en-US/reports.json";
import settings from "../../../locales/en-US/settings.json";
import shell from "../../../locales/en-US/shell.json";
import supervise from "../../../locales/en-US/supervise.json";
import teams from "../../../locales/en-US/teams.json";
import timer from "../../../locales/en-US/timer.json";

export const resources = {
	account,
	admin,
	common,
	errors,
	feed,
	insights,
	reports,
	settings,
	shell,
	supervise,
	teams,
	timer,
};
